import React from "react";
import { ReactComponent as DDxExamplePrompts } from "../../../assets/images/ddx-example-prompts.svg";

type ExamplePromptsProps = {
  onClickPrompt: (prompt: string) => void;
  disabled?: boolean;
};

const EXAMPLE_PROMPTS: string[] = [
  "Chest pain with shortness of breaths in night",
  "Headache and visual changes",
  "Shortness of breath and fever",
  "Joint pain and morning stiffness",
];

const ExamplePrompts: React.FC<ExamplePromptsProps> = ({
  onClickPrompt,
  disabled = false,
}) => {
  return (
    <div
      className={`my-4 bg-gradient-to-r from-[#EAE0FC] to-[#F5EEFA] py-3.5 rounded-xl flex flex-col gap-2.5 ${
        disabled && "opacity-50 pointer-events-none"
      }`}
    >
      <p className="text-[#454551] font-semibold text-sm text-left mx-3.5">
        Try Example Prompts
      </p>
      <div className="flex flex-row items-stretch px-3.5 overflow-x-scroll gap-4 no-scrollbar">
        {EXAMPLE_PROMPTS.map((prompt, i) => (
          <button
            onClick={() => onClickPrompt(prompt)}
            key={i.toString()}
            className="min-w-56 flex flex-row items-center gap-2.5 py-1 px-3 rounded-xl bg-white"
          >
            <DDxExamplePrompts className="min-h-5 min-w-5" />
            <p className="text-[#4B4AD5] text-xs leading-5 font-medium text-left">
              {prompt}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExamplePrompts;
